module.exports = __webpack_public_path__ + "static/media/createdAt.c9a9071d.svg";